import { useHead, useNuxtApp } from '#imports'
import type { MaybeRefOrGetter } from 'vue'

import { useAddCanonicalLink } from '~/scopes/seo/composables/useAddCanonicalLink'

export function useHubHead() {
  const nuxtApp = useNuxtApp()

  function setHead({
    title,
    description,
  }: {
    title: string | undefined
    description: MaybeRefOrGetter<string | undefined>
  }) {
    // This allows us to call useHead in a context where we don't have access to the Nuxt App
    // for example, after awaiting a function
    void nuxtApp.runWithContext(() => {
      useAddCanonicalLink()
      useHead({
        title,
        meta: [
          {
            name: 'description',
            content: description,
          },
          {
            content: title,
            key: 'og:title',
            property: 'og:title',
          },
          {
            content: description,
            key: 'og:description',
            property: 'og:description',
          },
          {
            content: title,
            key: 'twitter:title',
            property: 'twitter:title',
          },
          {
            content: description,
            key: 'twitter:description',
            property: 'twitter:description',
          },
        ],
      })
    })
  }

  return { setHead }
}
